import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { CustomerVenueNoteItem } from "src/app/shared/models/CustomerVenueNote.item";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-customer-note-detail",
	templateUrl: "./customer-note-detail.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerNoteDetailComponent implements OnInit {
	customerKey: string;
	@Input() venueKey: number;

	customerNoteList: CustomerVenueNoteItem[];
	customerNoteSelected: CustomerVenueNoteItem;

	moment: any = moment;

	user: User;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService,
		public customerService: CustomerService
	) {}

	ngOnInit(): void {
		this.customerKey = this.customerService.customer.value.key;
		this.init();
	}

	async init() {
		this.user = await this.localStorage.get("user");

		this.noteInit();
		await this.noteGet();
	}

	noteInit() {
		this.customerNoteSelected = new CustomerVenueNoteItem({
			pk: `${this.customerKey}_${this.venueKey}`,
			sk: moment().valueOf().toString(),
			authorUserKey: this.user.key,
			created: moment().format(),
		});
	}

	async noteGet() {
		const resp = await this.focuslink.customerVenueNoteGet(this.venueKey, this.customerKey);
		this.customerNoteList = resp.map((i) => new CustomerVenueNoteItem(i));
		this.customerNoteList.sort((a, b) => +b.sk - +a.sk);
	}

	async notePost() {
		this.focuslink.customerVenueNotePost(this.venueKey, this.customerKey, this.customerNoteSelected);
		this.customerNoteSelected.authorUser = this.user;
		if (!this.customerNoteList) {
			this.customerNoteList = [];
		}
		console.log(this.customerNoteList);
		this.customerNoteList.push(this.customerNoteSelected);
		this.noteListRefresh();
		this.noteInit();
	}

	async noteDelete(rec: CustomerVenueNoteItem) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete this customer note?`,
			accept: async () => {
				this.focuslink.customerVenueNoteDelete(this.venueKey, this.customerKey, rec.sk);
				this.customerNoteList.splice(
					this.customerNoteList.findIndex((i) => i.sk === rec.sk),
					1
				);
				this.noteListRefresh();
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	noteListRefresh() {
		const tempList = [...this.customerNoteList];
		this.customerNoteList = [];
		this.customerNoteList = [...tempList];
		this.customerNoteList.sort((a, b) => +b.sk - +a.sk);
	}
}
